<template>
  <div class="home-wrap" :class="'theme-'+theme">
    <div class="h-wrap">
      <v-head class="o-head container" :change-theme="changeMainTheme"></v-head>
    </div>
    <div class="c-wrap container">

      <v-side :class="{'fixed-side': true}" class="s-content"></v-side>

      <div class="c-content">
        <v-la-ba @click="openDialog" :list="notices" class="s-horn"></v-la-ba>

        <!-- 内容 -->
        <router-view/>
      </div>
    </div>

    <!-- 注单操作通知弹窗 -->
    <div class="order-notify-overlay" v-if="orderNotifyList.length > 0">
      <div class="order-notify-dialog">
        <div class="order-notify-header">
          <span class="order-notify-title">{{ currentNotify.title }}</span>
          <span class="order-notify-close" @click="dismissAllOrderNotify">&times;</span>
        </div>
        <div class="order-notify-body">
          <p v-for="(line, i) in currentNotify.content ? currentNotify.content.split('\n') : []" :key="i">{{ line }}</p>
        </div>
        <div class="order-notify-footer">
          <div class="order-notify-nav" v-if="orderNotifyList.length > 1">
            <button class="order-notify-nav-btn" :disabled="notifyIndex <= 0" @click="notifyIndex--">&lt; 上一条</button>
            <span class="order-notify-counter">{{ notifyIndex + 1 }} / {{ orderNotifyList.length }}</span>
            <button class="order-notify-nav-btn" :disabled="notifyIndex >= orderNotifyList.length - 1" @click="notifyIndex++">&gt; 下一条</button>
          </div>
          <button class="order-notify-btn t_btn-d active" @click="dismissAllOrderNotify">全部已读</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Notice from '../../components/notice';
  import VHead from '../../components/common/headTabs';
  import VSide from '../../components/common/sideBars';
  import VLaBa from '../../components/c-laba';
  import {mapActions, mapState, mapGetters} from 'vuex';
  import Bus from '../../utils/bus';
  import { getOrderNotify, markOrderNotifyRead } from '../../service/home';

  const find = (cb, el) => {
    if (el.name === 'app_notice') return cb(el);
    if (el.$children.length > 0) el.$children.forEach(child => find(cb, child));
  };

  export default {
    name: 'home',
    components: {
      Notice,
      VHead,
      VSide,
      VLaBa,
    },
    data() {
      return {
        orderNotifyList: [],
        orderNotifyTimer: null,
        notifyIndex: 0,
      };
    },
    computed: {
      ...mapGetters('root', [
        'theme'
      ]),
      ...mapState('home', [
        'notices'
      ]),
      ...mapState([
        'notice'
      ]),
      currentNotify() {
        return this.orderNotifyList[this.notifyIndex] || {};
      },
    },
    watch: {
      theme: {
        handler(val) {
          Bus.$emit('changeTheme', val);
        },
        immediate: true
      }
    },
    mounted() {
      this.startOrderNotifyPolling();
    },
    beforeDestroy() {
      this.stopOrderNotifyPolling();
    },
    methods: {
      ...mapActions('root', [
        'changeMainTheme'
      ]),
      ...mapActions({
        loadInfo: 'loadNoticeDetail'
      }),
      openDialog(item) {
        if (!item.id) return;
        this.loadInfo(item.id);
        this.$MessageBox.show('d37', {
          title: '平台公告',
          noticeId: item.id
        });
      },
      startOrderNotifyPolling() {
        this.fetchOrderNotify();
        this.orderNotifyTimer = setInterval(() => {
          this.fetchOrderNotify();
        }, 15000);
      },
      stopOrderNotifyPolling() {
        if (this.orderNotifyTimer) {
          clearInterval(this.orderNotifyTimer);
          this.orderNotifyTimer = null;
        }
      },
      async fetchOrderNotify() {
        try {
          const res = await getOrderNotify();
          if (res.result === 'ok' && res.data && res.data.length > 0) {
            this.orderNotifyList = res.data;
            this.notifyIndex = 0;
          }
        } catch (e) {}
      },
      async dismissAllOrderNotify() {
        const list = this.orderNotifyList.slice();
        this.orderNotifyList = [];
        this.notifyIndex = 0;
        for (const item of list) {
          try { await markOrderNotifyRead(item.id); } catch (e) {}
        }
      },
    }
  }
</script>

<style>
  html, body {
    height: 100%;
  }
</style>
<style scoped lang="stylus">
@media screen and (max-width: 900px) {
  .c-content{width:calc(100% - 36vw) !important;}
}
  .home-wrap
    min-width 1250px
    position relative
    width 100%

    .h-wrap
      top 0
      left 0
      width 100%
      height 44px
      z-index 1000
      position absolute

      .o-head
        margin 0 auto

    .c-wrap
      height 100%
      margin 0 auto
      position relative
      overflow hidden
      padding-top 48px

      .s-content
        float left

      .c-content
        float right
        width calc(100% - 220px)
        min-height 830px

      .s-horn
        width 100%
        background linear-gradient(#FFFFFF, #ECECEC)
        margin-bottom 5px
        border-radius 2px
        background-color #ffffff

  .theme-2 .home-wrap .h-wrap
  {
	//background linear-gradient(#28b32a,#05971e)!important;
  }

  .order-notify-overlay
    position fixed
    top 0
    left 0
    right 0
    bottom 0
    background rgba(0, 0, 0, 0.5)
    z-index 9999
    display flex
    align-items center
    justify-content center

  .order-notify-dialog
    background #fff
    border-radius 8px
    box-shadow 0 4px 20px rgba(0, 0, 0, 0.3)
    width 420px
    max-width 90%
    overflow hidden
    animation orderNotifyFadeIn 0.3s ease

  .order-notify-header
    display flex
    justify-content space-between
    align-items center
    padding 14px 20px
    background linear-gradient(135deg, #ff6b6b 0%, #ee5a24 100%)
    color #fff

  .order-notify-title
    font-size 16px
    font-weight bold

  .order-notify-close
    font-size 22px
    cursor pointer
    line-height 1
    opacity 0.8
    &:hover
      opacity 1

  .order-notify-body
    padding 20px 20px
    font-size 14px
    color #333
    line-height 1.6
    min-height 60px
    p
      margin 2px 0

  .order-notify-footer
    padding 12px 20px 18px
    text-align center

  .order-notify-nav
    display flex
    align-items center
    justify-content center
    margin-bottom 12px

  .order-notify-nav-btn
    background none
    border 1px solid #dcdfe6
    color #606266
    padding 4px 12px
    border-radius 3px
    font-size 13px
    cursor pointer
    transition all 0.2s
    &:hover:not(:disabled)
      color #409eff
      border-color #409eff
    &:disabled
      opacity 0.4
      cursor not-allowed

  .order-notify-counter
    margin 0 16px
    font-size 13px
    color #999

  .order-notify-btn
    min-width 100px
    padding 8px 28px
    border-radius 3px
    font-size 14px
    cursor pointer

  @keyframes orderNotifyFadeIn
    from
      opacity 0
      transform scale(0.9)
    to
      opacity 1
      transform scale(1)
</style>



// WEBPACK FOOTER //
// src/pages/home/index.vue